import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { BaremetalPaymentPeriod } from '../../@types/instance';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

interface Vars {
    id: number;
    period: BaremetalPaymentPeriod;
}

export function useChangeBaremetalPaymentPeriodMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, period }: Vars) =>
            Endpoints.v1.Baremetals.changePaymentPeriod(id, period),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['api.v1.baremetals.list'] });
            queryClient.invalidateQueries({ queryKey: ['api.v1.baremetals.get'] });
            notifications.show({
                title: t('baremetal.paymentPeriodChangedTitle'),
                message: t('baremetal.paymentPeriodChangedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('baremetal.paymentPeriodFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
